export const cookieExpiresDutaion: Duration = { years: 1 };

export const cookieConsentTestId = "components/fragments/modeless-dialog/cookie-consent-modeless-dialog";
export const grantedButtonTestId =
  "components/fragments//modeless-dialog/cookie-consent-modeless-dialog/Button-granted";
